<template>
<div v-if="!eventsLoading">
  <b class="title-main">{{events.length}} {{ events.length == 1 ? 'ähnliches Bewegungsangebot' : 'ähnliche Bewegungsangebote'}} gefunden</b>
  <events-list :events="events" :loading="eventsLoading" context="similar" />
</div>
</template>
<script>

import EventsList from "../components/_eventsList.vue"
import axios from 'axios';

export default {
  name: 'Similar',
	components: {
    EventsList,
	},
  data(){
    return {
      events: [],
      eventsLoading: true
    }
  },
  created(){
    axios.get(`/events/similar/${window.currentEventId}`)
    .then(r => {
      this.events = r.data.events
      this.eventsLoading = false
    })
  },



}
</script>
